import React from "react";
import styles from "../components/Companies.scss";

const Companies = props => {
  const list = props.list;
  const element = list.map(icon => (
    <img key={icon.toString()} className={styles.companiesItem} src={icon} />
  ));

  return <div className={styles.companies}>{element}</div>;
};

export default Companies;



// WEBPACK FOOTER //
// ./src/routes/candidate/signUpMarketing2/components/Companies.js